/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '@ng-bootstrap/ng-bootstrap/modal/modal-window';
const styles_NgbModalWindow:any[] = ([] as any[]);
export const RenderType_NgbModalWindow:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_NgbModalWindow,data:{}});
export function View_NgbModalWindow_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵted(-1,(null as any),['\n    '])),(_l()(),i0.ɵeld(1,
      0,(null as any),(null as any),4,'div',[['role','document']],[[8,'className',
          0]],(null as any),(null as any),(null as any),(null as any))),(_l()(),i0.ɵted(-1,
      (null as any),['\n        '])),(_l()(),i0.ɵeld(3,0,(null as any),(null as any),
      1,'div',[['class','modal-content']],(null as any),(null as any),(null as any),
      (null as any),(null as any))),i0.ɵncd((null as any),0),(_l()(),i0.ɵted(-1,(null as any),
      ['\n    '])),(_l()(),i0.ɵted(-1,(null as any),['\n    ']))],(null as any),(_ck,
      _v) => {
    var _co:i1.NgbModalWindow = _v.component;
    const currVal_0:any = ('modal-dialog' + (_co.size? (' modal-' + _co.size): ''));
    _ck(_v,1,0,currVal_0);
  });
}
export function View_NgbModalWindow_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'ngb-modal-window',
      [['role','dialog'],['style','display: block;'],['tabindex','-1']],[[8,'className',
          0]],[[(null as any),'keyup.esc'],[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('keyup.esc' === en)) {
          const pd_0:any = ((<any>i0.ɵnov(_v,1).escKey($event)) !== false);
          ad = (pd_0 && ad);
        }
        if (('click' === en)) {
          const pd_1:any = ((<any>i0.ɵnov(_v,1).backdropClick($event)) !== false);
          ad = (pd_1 && ad);
        }
        return ad;
      },View_NgbModalWindow_0,RenderType_NgbModalWindow)),i0.ɵdid(1,4440064,(null as any),
      0,i1.NgbModalWindow,[i0.ElementRef,i0.Renderer2],(null as any),(null as any))],
      (_ck,_v) => {
        _ck(_v,1,0);
      },(_ck,_v) => {
        const currVal_0:any = ('modal fade show' + (i0.ɵnov(_v,1).windowClass? (' ' + i0.ɵnov(_v,
            1).windowClass): ''));
        _ck(_v,0,0,currVal_0);
      });
}
export const NgbModalWindowNgFactory:i0.ComponentFactory<i1.NgbModalWindow> = i0.ɵccf('ngb-modal-window',
    i1.NgbModalWindow,View_NgbModalWindow_Host_0,{backdrop:'backdrop',keyboard:'keyboard',
        size:'size',windowClass:'windowClass'},{dismissEvent:'dismiss'},['*']);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci9qZW5raW5zX2hvbWUvd29ya3NwYWNlL0NMQUlNU19QSVBFTElORS9DTE1UTEtfVUlfQVBQX1BJUEVMSU5FL25vZGVfbW9kdWxlcy9AbmctYm9vdHN0cmFwL25nLWJvb3RzdHJhcC9tb2RhbC9tb2RhbC13aW5kb3cubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vdmFyL2plbmtpbnNfaG9tZS93b3Jrc3BhY2UvQ0xBSU1TX1BJUEVMSU5FL0NMTVRMS19VSV9BUFBfUElQRUxJTkUvbm9kZV9tb2R1bGVzL0BuZy1ib290c3RyYXAvbmctYm9vdHN0cmFwL21vZGFsL21vZGFsLXdpbmRvdy5kLnRzIiwibmc6Ly8vdmFyL2plbmtpbnNfaG9tZS93b3Jrc3BhY2UvQ0xBSU1TX1BJUEVMSU5FL0NMTVRMS19VSV9BUFBfUElQRUxJTkUvbm9kZV9tb2R1bGVzL0BuZy1ib290c3RyYXAvbmctYm9vdHN0cmFwL21vZGFsL21vZGFsLXdpbmRvdy5kLnRzLk5nYk1vZGFsV2luZG93Lmh0bWwiLCJuZzovLy92YXIvamVua2luc19ob21lL3dvcmtzcGFjZS9DTEFJTVNfUElQRUxJTkUvQ0xNVExLX1VJX0FQUF9QSVBFTElORS9ub2RlX21vZHVsZXMvQG5nLWJvb3RzdHJhcC9uZy1ib290c3RyYXAvbW9kYWwvbW9kYWwtd2luZG93LmQudHMuTmdiTW9kYWxXaW5kb3dfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCJcbiAgICA8ZGl2IFtjbGFzc109XCInbW9kYWwtZGlhbG9nJyArIChzaXplID8gJyBtb2RhbC0nICsgc2l6ZSA6ICcnKVwiIHJvbGU9XCJkb2N1bWVudFwiPlxuICAgICAgICA8ZGl2IGNsYXNzPVwibW9kYWwtY29udGVudFwiPjxuZy1jb250ZW50PjwvbmctY29udGVudD48L2Rpdj5cbiAgICA8L2Rpdj5cbiAgICAiLCI8bmdiLW1vZGFsLXdpbmRvdz48L25nYi1tb2RhbC13aW5kb3c+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7b0JDQUEsOENBQ0k7TUFBQTtVQUFBLDhEQUErRTtNQUFBLCtCQUMzRTtNQUFBO01BQUEscUNBQTJCLGtCQUErQjtNQUFBLGFBQ3hEOzs7SUFGRDtJQUFMLFdBQUssU0FBTDs7OztvQkNESjtNQUFBO1VBQUE7UUFBQTtRQUFBO1VBQUE7VUFBQTtRQUFBO1FBQUE7VUFBQTtVQUFBO1FBQUE7UUFBQTtNQUFBLDJEQUFBO01BQUE7O1FBQUE7O1FBQUE7WUFBQTtRQUFBLFdBQUEsU0FBQTs7Ozs7In0=



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/CLAIMS_PIPELINE/CLMTLK_UI_APP_PIPELINE/src/$$_gendir/node_modules/@ng-bootstrap/ng-bootstrap/modal/modal-window.ngfactory.ts